export default "__VITE_ASSET__V8m_s0Jm__"